export default __webpack_public_path__ + "static/media/home-events-conference-img-01.ac1c94a0.jpg";